/**
 * Analytics Debug — logger condicional por ambiente
 */

import { config } from '../config';

export const debug = {
  log: (...args: unknown[]) => {
    if (config.isDev) console.log('[Analytics]', ...args);
  },
  info: (...args: unknown[]) => {
    if (config.isDev) console.info('[Analytics]', ...args);
  },
  warn: (...args: unknown[]) => {
    if (config.isDev) console.warn('[Analytics]', ...args);
  },
  error: (...args: unknown[]) => {
    console.error('[Analytics]', ...args);
  },
  event: (name: string, params: unknown, meta?: { mode?: string }) => {
    if (config.isDev) {
      console.log(
        `%c[Analytics] EVENT`,
        'color: #0B7B7B; font-weight: bold;',
        { event: name, params, mode: meta?.mode || 'client', env: config.isDev ? 'dev' : 'prod' }
      );
    }
  },
};
